module.exports = __webpack_public_path__ + "static/media/shrink-details.4d5bc58d.jpg";